import React from "react";

export default function DonateBar() {
  return (
    <div className='ctaBucket  container'>
      <button className='btn btn-lg btn-danger btnDonate'>
        Donate anything
      </button>
    </div>
  );
}
